import type { VfConfig } from '#types/config/components/vf'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    control: {
      default: 'bg-grey-30',
      disabled: 'b b-grey-10 bg-grey-30',
      disabledSelected: 'b b-grey-60 bg-grey-10'
    }
  }
} satisfies RecursivePartial<VfConfig['switch']>
